export const CONTENT_LAB = 'content-lab';
export const ASSETS = 'assets';
export const PROJECTS = 'projects';
export const FOLDERS = 'folders';
export const CURRENT_SUBSCRIPTION = 'currentSubscription';
export const DUBBING_LANGUAGES = 'dubbingLanguages';
export const CAPTIONS_LANGUAGES = 'captionsLanguages';
export const CAPTIONS_STYLES = 'captionsStyles';
export const ASSET_FILTERS = 'assetsFilters';
export const PLANS = 'plans';
export const PROJECTS_STATUS = 'projects-status';
export const INITIALIZE_REPHRASING_PROJECT = 'initializeRephrasingProject';
export const VOICES = 'voices';
